import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LumberPrice } from '@paragon/contract-library';

const initialState: { [guid: string]: LumberPrice } = {};

const lumberPricesSlice = createSlice({
  name: 'lumberPrices',
  initialState,
  reducers: {
    setLumberPrices: (state, action: PayloadAction<readonly LumberPrice[]>) => {
      for (const lumberPrice of action.payload) {
        state[lumberPrice.guid] = lumberPrice;
      }
    },
  },
});

export const { setLumberPrices } = lumberPricesSlice.actions;
export const lumberPrices = lumberPricesSlice.reducer;
